import React from 'react';

const ChatMessage = ({ message, onOptionSelect }) => {
    const isBot = message.sender === 'bot';
    return (
        <div style={isBot ? styles.botMessage : styles.userMessage}>
            <div style={message.isAiPlan ? styles.aiBubble : styles.bubble(isBot)}>
                {message.text.split('\n').map((line, i) => <p key={i} style={{margin: '0 0 8px 0'}}>{line}</p>)}
            </div>
            {isBot && message.options && !message.isAiPlan && (
                <div style={styles.optionsContainer}>
                    {message.options.map((opt, i) => (
                         <OptionButton key={i} onSelect={() => onOptionSelect(opt)} isAiButton={opt.text.includes('✨')}>
                            {opt.text}
                        </OptionButton>
                    ))}
                </div>
            )}
        </div>
    );
};

const OptionButton = ({ children, onSelect, isAiButton }) => (
    <button style={isAiButton ? styles.aiOptionButton : styles.optionButton} onClick={onSelect}>
        {children}
    </button>
);

// --- Styles ---
const styles = {
    botMessage: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginBottom: '15px',
    },
    userMessage: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginBottom: '15px',
    },
    bubble: (isBot) => ({
        backgroundColor: isBot ? '#e9e9eb' : '#007aff',
        color: isBot ? '#000' : '#fff',
        padding: '12px 18px',
        borderRadius: '20px',
        maxWidth: '85%',
        lineHeight: '1.5',
        fontSize: '1.1rem',
    }),
    aiBubble: {
        backgroundColor: '#e6f7ff',
        color: '#005280',
        padding: '15px 20px',
        borderRadius: '20px',
        maxWidth: '85%',
        lineHeight: '1.6',
        fontSize: '1.1rem',
        border: '2px solid #91d5ff',
    },
    optionsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: '10px',
        gap: '8px',
        width: '100%',
    },
    optionButton: {
        backgroundColor: '#fff',
        border: '2px solid #007aff',
        color: '#007aff',
        padding: '12px 20px',
        borderRadius: '20px',
        cursor: 'pointer',
        fontSize: '1rem',
        fontWeight: '600',
        transition: 'all 0.2s ease',
        textAlign: 'center',
        width: 'fit-content',
    },
    aiOptionButton: {
        backgroundColor: '#007aff',
        border: '2px solid #007aff',
        color: '#fff',
        padding: '14px 22px',
        borderRadius: '22px',
        cursor: 'pointer',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        transition: 'all 0.2s ease',
        textAlign: 'center',
        width: 'fit-content',
        boxShadow: '0 2px 5px rgba(0, 122, 255, 0.3)',
    },
};

export default ChatMessage;